export default "__VITE_ASSET__D1L2hT$$__"